class UserController {

    constructor(
        $uibModal,
        UserService
    ){
        'ngInject';

        this.$uibModal = $uibModal;
        this.UserService = UserService;
    }

    $onInit() {
        this.statusOptions = [
            {
                text: 'User'
            },
            {
                text: 'Holding'
            },
            {
                text: 'Deactivated'
            }
        ];

        this.statusOption = this.statusOptions.filter((status) => status.text === this.user.status)[0];
        this.roleOption = this.roleList.filter((role) => role.id === this.user.user_role_id)[0];
        this.successfulUpdate = {};
        this.successfulStatusUpdate = false;
    }

    /***
     * Open the Survey Settings modal.
     */
    openClientsModal() {
        this.$uibModal.open({
            component: 'UserModal',
            size: 'md',
            windowClass: 'custom-modal user-modal',
            resolve: {
                user: this.UserService.getUser(this.user.id),
                customPermissions: () => this.customPermissionList,
                clientList: () => this.clientList,

            }
        });
    }

    openCustomPermissionModal() {
        this.$uibModal.open({
            component: 'CustomPermissionModal',
            size: 'md',
            windowClass: 'custom-modal custom-permission-modal',
            resolve: {
                user: () => this.UserService.getUser(this.user.id),
                permissionList: () => this.customPermissionList,

            }
        });
    }

    /***
     * Makes a request to update this User with its updated status.
     *
     * @param status    the updated status for the user.
     */
    updateStatus(status) {
        this.statusOption = status;
        const data = {
            status: status.text
        };
        this.UserService.updateUser(this.user.id, data)
             .then((successResponse) => {
                this.successfulStatusUpdate = true;

            }, (errorResponse) => {
                alert(`There was an error updating user "${this.user.email_addr}"`);
            });
    }

    /***
     * Makes a request to update this User with its updated role.
     *
     * @param role      the updated role for the user.
     */
    updateRole(role) {
        this.roleOption = role;
        const data = {
            user_role_id: role.id
        };
        this.user.user_role_id = role.id;
        this.UserService.updateUser(this.user.id, data)
             .then((successResponse) => {
                this.successfulRoleUpdate = true;

            }, (errorResponse) => {
                alert(`There was an error updating user "${this.user.email_addr}"`);
            });
    }

    updateUserPermission(permission_name) {
        const permissionValue = this.user[permission_name] ? 1 : 0;
        let data = {};
        data[permission_name] = permissionValue;

        this.UserService.updateUser(this.user.id, data)
            .then((successResponse) => {
                this.successfulUpdate[permission_name] = true;
            }, (errorResponse) => {
                alert(`There was an error updating user "${this.user.email_addr}"`);
            })
    }

}

export default UserController;


// WEBPACK FOOTER //
// ./app/components/user-admin/user/user-controller.js